// extracted by mini-css-extract-plugin
export default {"wrapper":"search_result_commentary-module__wrapper--3Ppm5"};